<template>
  <user-agreement :user-agreement-type="userAgreementType" showPageTitle></user-agreement>
</template>

<script>
import UserAgreement from '@/components/User/UserAgreement.vue';
import { isMobile } from '@/utilities/tools'
export default {
  name: "Privacy",
  data () {
    return {
      userAgreementType: 2
    }
  },
  components: {
    UserAgreement
  },
  beforeMount () {
    if(isMobile()) {
      window.location.href = `${process.env.VUE_APP_MOBILE_URL}/Rccl.UserCenter/Privacy`;
    }
  },
  methods: {
  }
}
</script>

<style lang="less">
</style>